import * as React from "react";

function WebsiteDevelopmentSvg(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={40} height={40} viewBox="0 0 40 40" {...props}>
      <g fill="none" stroke="#fff" strokeWidth={2}>
        <rect width={36} height={26} x={2} y={7} rx={3} />
        <path d="M2 13h36M9 4h2M15 4h2M21 4h2" />
      </g>
    </svg>
  );
}

export default WebsiteDevelopmentSvg;
